import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { IrbEditorsEvents, IEvent, IrbAppEvents } from "@irb-common/events";
import { IRebalanceTypeItem, IrbCreateRebalanceService } from '@irb/irb-create-rebalance/irb-create-rebalance.service';
import { FormControl } from '@angular/forms';
import { IrbRebalanceEditor } from '@irb/irb-editors/irb-editors.rebalance.base';
import { IAnalysisPackage, ISaveRebalanceResponse, ISaveRebalanceStatus, ISaveRebalanceAsync, ISchedulerDTO } from '../rebalance/irb-rebalance.model';
import { IAlertDialogData } from '@irb/app.model';
import { RebalanceService } from '../rebalance/rebalance.service';
import { ISmartFilterDto } from '../irb-editors.model';
import { RebalanceIncludedPortfolioComponent } from '../rebalance/rebalance-included-portfolio/rebalance-included-portfolio.component';
import {AnalyticsService} from "@irb-common/analytics/analytics.service";

@Component({ standalone: false,
  selector: 'irb-editor-full-rebalance',
  templateUrl: './editor-full-rebalance.component.html',
  styleUrls: ['./editor-full-rebalance.component.scss', "../../irb-common/styles/dialog.scss", "../editor-sidebar/editor-sidebar.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class EditorFullRebalanceComponent extends IrbRebalanceEditor implements OnInit {
    @ViewChild("body") body: ElementRef;
    @ViewChild('everyNDays') everyNDays: any;
    @ViewChild("includedportfolio") includedportfolio: RebalanceIncludedPortfolioComponent;
    params: any;
    createRebalanceDate: any;
    rebalanceTypeLists: IRebalanceTypeItem[];
    selectedRebalanceType = new FormControl('');
    headerRebalanceType: any;
    defaultExpandedPanels: Array<string> = ["fullRebalance_included_portfilio", "fullRebalance_scheduler"];
    RebalanceResultId: string;
    isSchedulerRemove: boolean = false;
    summarySource: string;
    rebalanceTitle: string;    
    isReadOnly: boolean = false;
    analysisName: string = 'Full Reb - ';
    analysisType: string = "Full rebalance";
    isUnitTest: boolean = false;
    
  constructor(private cdr: ChangeDetectorRef,
    private readonly rebalanceService: RebalanceService,
    public ats: AnalyticsService
    ) {
      super();
      this.identifier = "analysisId";
  }

  ngOnInit() {
     this.createRebalanceDate = this.datePipe.transform(this.createRebalanceDate, 'yyyy-MM-dd');
   }

  get(event: IEvent) {
    super.get(event);
    let eventData: IAnalysisPackage;
    let todayDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
    if (event.data) {
      this.rebalanceService.setRebalanceSource(event.data.source || null);
    }
    if(event.data && event.data.navigationSource === "schedulePage"){
      
      this.saveLabel = "Schedule";
      this.ignoreUnsavedChanges = false;
      this.rebalanceTitle = "Create Full Rebalance";

       eventData = {
         analysisType: this.analysisType,
         isNew: true,
         isUIdeleted: false,
         schedulerFrequency: "None",
         navigationSource:event.data.navigationSource,
         smartFilterDto: (event.data && event.data.smartFilterDto) ? event.data.smartFilterDto : {
          analysisType: this.analysisType,
          isCategoryAll: false,
          isCategoryBlank: false,
          isModelAll: false,
          isModelBlank: false,
          modelUpdated: false,
          sfCategoryDtoList: null,
          sfModelDtoList: null,
          smartFilterDays: null,
          analysisPortDtoList: []
        } as ISmartFilterDto,

         scheduler: {
           isActive: true,
           scheduleType: "Recurring"
         } as ISchedulerDTO
       } as IAnalysisPackage;

       this.isReadOnly = false;
       this.isSchedulerRemove = false;
      this.applyRebalanceData(event, eventData, todayDate);
      this.defaultExpandedPanels = this.getDefaultExpandedPanels();
      this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-full-rebalance", this.defaultExpandedPanels, false);
      this.cdr.detectChanges();
      setTimeout(() => this.onResize());
    }else{
    if (event.data !== null && event.data !== undefined && event.data.analysisId !== null && event.data.analysisId !== undefined) {
      eventData = event.data;
      this.summarySource = event.data.source;
      if (this.summarySource === 'resultSummary' || this.summarySource === 'portfolioResultDetail') {
        this.rebalanceTitle = "View Full Rebalance";
        this.isSchedulerRemove = true;
        this.rebalanceService.getHistoryDetail(event.data.analysisId).subscribe((data: any) => {
          eventData = data.responseData;
          eventData.schedulerFrequency = "None";
          this.load(eventData);
        });
      }

      if (this.summarySource === 'Scheduled') {
        this.ats.trackScheduledRebalancesEditEvent();
        this.saveLabel = "Schedule";
        this.ignoreUnsavedChanges = false;
        this.isReadOnly = false;
        this.rebalanceTitle = "Edit Full Rebalance";
        this.isSchedulerRemove = false;
        this.rebalanceService.getRebalanceDetail(event.data.analysisId).subscribe((data: any) => {
          eventData = data.responseData;
          if (!eventData.tradeExpln) {
            eventData.tradeExpln = '';
          }
          this.load(eventData);
        });
      }
    } else {
      
      this.ignoreUnsavedChanges = true;
      this.rebalanceTitle = "Create Full Rebalance";
      this.saveLabel = "Process";
      eventData = {
        analysisType: "Full rebalance",
        isNew: true,
        isUIdeleted: false,
        isSysSuggestion: true,
        analysisName: this.analysisName + todayDate,
        schedulerFrequency: "None",
        tradeExpln: "",
        isUIAllPort: false,
        smartFilterDto: (event.data && event.data.smartFilterDto) ? event.data.smartFilterDto : {
          analysisType: this.analysisType,
          isCategoryAll: false,
          isCategoryBlank: false,
          isModelAll: false,
          isModelBlank: false,
          modelUpdated: false,
          sfCategoryDtoList: null,
          sfModelDtoList: null,
          smartFilterDays: null,
          analysisPortDtoList: []
        } as ISmartFilterDto,
        scheduler: {
          isActive: false,
          scheduleType: "Adhoc"
        } as ISchedulerDTO
      } as IAnalysisPackage;

      if (event.data && event.data.modelId) {
        eventData.modelId = event.data.modelId;
        eventData.modelName = event.data.modelName;
      }

      this.isReadOnly = false;
      this.summarySource = event.data.source;
      this.isSchedulerRemove = false;
      this.applyRebalanceData(event, eventData, todayDate);
      this.defaultExpandedPanels = this.getDefaultExpandedPanels();
      this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-full-rebalance", this.defaultExpandedPanels, false);
      this.cdr.detectChanges();
      setTimeout(() => this.onResize());
    }

    if (this.summarySource !== null && this.summarySource !== undefined && this.summarySource === "resultSummary") {
      this.isReadOnly = true;
    }
    if(this.summarySource !== null && this.summarySource !== undefined && this.summarySource === "rebalancePortfolioDialog"){
      if(this.data.smartFilterDto.analysisPortDtoList !==null && this.data.smartFilterDto.analysisPortDtoList !==undefined){
        this.isReadOnly = false;
        this.isModified = true;
        this.originalData.summarySource = "rebalancePortfolioDialog";
        this.data.tradeExpln = undefined;
        this.cdr.detectChanges();
      }
    }
   }
  }

  load(data: IAnalysisPackage) {
    super.load(data);
    this.defaultExpandedPanels = this.getDefaultExpandedPanels();
    this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-full-rebalance", this.defaultExpandedPanels, false);
    this.cdr.detectChanges();
    setTimeout(() => this.onResize());
  }

  saveRebalance() {
    this.as.fireEvent(IrbEditorsEvents.SAVE_START, { "slot": this.slot });
    const includePortfolioList = this.includedportfolio.getRowData();
    this.data.smartFilterDto.analysisPortDtoList = includePortfolioList;
    this.data.smartFilterDto.analysisPortDtoListCount = includePortfolioList.length;
    this.validateInput().subscribe(errors => {        
      if (errors.length > 0) { 
        let errMsg: string = errors.join("\n");

        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: "Alert",
            msg: errMsg,
            dProceedBtnLabel: "Ok",
            dType: "ERROR"
        } as IAlertDialogData);
        
        this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
      } else {
        if(this.data.schedulerFrequency === "Daily"){
          this.data.schedulerFrequency = this.data.scheduler.reccuringFreqType;
        }

        const saveData: any = JSON.parse(JSON.stringify(this.data));
        delete saveData.navigationSource;
        this.trackEditEvent(this.data);

        if(saveData.smartFilterDto.analysisPortDtoList.length >= this.portfolioThreshold) {
          this.crbservice.saveRebalanceAsync(saveData).subscribe((data: ISaveRebalanceAsync) => {            
            this.checkSaveRebalanceAsyncStatus(data.rprasId);
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            this.setGlobalError();
          });
        } else {
          this.crbservice.saveRebalance(saveData).subscribe((data: ISaveRebalanceResponse) => {
            this.completeSaveRebalance(data);
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            this.setGlobalError();
          });
        }
      }
    });
  }

  completeSaveRebalance(response: ISaveRebalanceResponse) {
    if (response.responseStatus === "SUCCESS") {      
      if (response.responseUtilityMap != null) {
        let analysisId = String(response.responseUtilityMap.analysisId);
        let rebalanceResultId = String(response.responseUtilityMap.rebalanceResultId);
        let rebalanceName = response.responseUtilityMap.rebalanceName;

        let submitTiQueueReq: any = {Package: analysisId, RebalanceResult: rebalanceResultId};

        let saveSuccessEventData: {};
        let hasPendFunc: boolean = this.hasPendingFunction;
        if (!hasPendFunc) {
          saveSuccessEventData = { "hasPendingFunction": hasPendFunc, "slot": this.slot };
          if (this.data.schedulerFrequency === "None") {
            this.submitPackageToQueue(submitTiQueueReq, rebalanceName, rebalanceResultId, hasPendFunc,saveSuccessEventData);
          } else {
            this.navigateToScheduledRebalances();
          }
        } else {
          saveSuccessEventData = { "hasPendingFunction": hasPendFunc, "data": rebalanceName+" Rebalance Submitted", "slot": this.slot };
          if (this.data.schedulerFrequency === "None") {
            this.submitPackageToQueue(submitTiQueueReq, rebalanceName, rebalanceResultId, hasPendFunc,saveSuccessEventData);
          }
        }
        
      }
      this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    } else {
      this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
      this.setGlobalError();
    }
  }

  submitPackageToQueue(submitTiQueueReq: any, rebalanceName: string, rebalanceResultId: any, hasPendFunc: boolean,saveSuccessEventData:any) {
    this.rebalanceService.submitPortfoliosToQueue(submitTiQueueReq).subscribe(() => {
      if (!hasPendFunc) {
        this.alertUserOnSubmissionOrSave(rebalanceName, rebalanceResultId,saveSuccessEventData);
      } else {
        setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, saveSuccessEventData); });
      }
    });    
  }

  alertUserOnSubmissionOrSave(rebalanceName: string, rebalanceResultId: any,saveSuccessEventData:any) {
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: "Rebalance Submitted",
      msg: rebalanceName,
      altMsg: "Go to rebalance results summary to check the status of this submission.",
      dProceedBtnLabel: "Go to Rebalance Result Summary",
      dType: "WARN",
      onProceed: (() => {
          this.navigateToResultSummary(rebalanceResultId);
        // this.closeWithoutSave();
      }).bind(this),
      onCancel: (() => {
          this.closeWithoutSave();
      }).bind(this)
    } as IAlertDialogData);

    setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS,saveSuccessEventData); });
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
      if (this.body) {
          const rect = this.body.nativeElement.getBoundingClientRect();
          let h = (window.innerHeight - rect.top - 10);

          h = (h < 200) ? 200 : h;
          this.bodyHeight = h + "px";
      }
  }

  getDefaultExpandedPanels() {
    let defaultExpandedPanels: Array<string> = ["fullRebalance_included_portfilio", "fullRebalance_scheduler"];
    // QC 168261
    // let source = this.rebalanceService.getRebalanceSource();
    // if(source!==undefined && source !== null && source !=='' && source.length > 0) {
    //   defaultExpandedPanels = ["fullRebalance_scheduler"];
    // }
    return defaultExpandedPanels;
  }

  getPortfolioCount() {
    if(this.data && this.data.isUIAllPort && this.data.isUIAllPort === true) {
      return "All portfolios included";
    }
    if(this.data?.smartFilterDto?.analysisPortDtoList !==null
        && this.data?.smartFilterDto?.analysisPortDtoList !==undefined
        && this.data?.smartFilterDto?.analysisPortDtoList?.length) {
      if(this.data?.smartFilterDto?.analysisPortDtoList?.length > 1) {
        return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolios included";
      } else if (this.data?.smartFilterDto?.analysisPortDtoList?.length === 1) {
        return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolio included";
      } else {
        return 0 + " portfolios included";
      }
    } else {
      return 0 + " portfolios included";
    }
  }
}
